import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link } from "react-router-dom";

function PrintSheet() {
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  return (
    <React.Fragment>
      <Header />
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Print Sheet
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xl-35 width-lg-60 width-md-80">
              <div className="card">
                <div className="card-header p-0 bg-white">
                  <h1 className="title-semibold p-4 fs-20 mb-0">
                    Buyer's/Warehouse Print Sheet
                  </h1>
                  <div className="sub-header bg-mid-grey px-4 cpy-14 border-top d-flex justify-content-between">
                    <p className="mb-0 fs-15 text-lite d-flex align-items-center">
                      Date:
                      <span className="text-dark fs-16 fw-medium ms-2">
                        5 March 2023
                      </span>
                    </p>
                    <p className="mb-0 fs-15 text-lite d-flex align-items-center">
                      Agent Name:
                      <span className="text-dark fs-16 fw-medium ms-2">
                        FEX-Fresh Express
                      </span>
                    </p>
                  </div>
                </div>
                <div className="card-body p-4">
                  <ul className="list-group">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <p className="mb-0 text-lite fw-medium fs-15">Type:</p>
                      <select
                        className="form-select input-sm float-end width-sm-30"
                        aria-label="Default select example"
                      >
                        <option value="1">Buyer's Sheet</option>
                        <option value="1">Werehouse Sheet</option>
                      </select>
                    </li>
                    <li className="list-group-item cpy-15">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                        />
                        <label
                          className="form-check-label cms-6"
                          htmlFor="flexRadioDefault1"
                        >
                          1st 20 VP Codes
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item cpy-15">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                        />
                        <label
                          className="form-check-label cms-6"
                          htmlFor="flexRadioDefault2"
                        >
                          2nd 20 VP Codes
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item cpy-15">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault3"
                        />
                        <label
                          className="form-check-label cms-6"
                          htmlFor="flexRadioDefault3"
                        >
                          3rd 20 VP Codes
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item cpy-15">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault4"
                        />
                        <label
                          className="form-check-label cms-6"
                          htmlFor="flexRadioDefault4"
                        >
                          4th 20 VP Codes
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item cpy-15">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault5"
                        />
                        <label
                          className="form-check-label cms-6"
                          htmlFor="flexRadioDefault5"
                        >
                          All VP Codes
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item cpy-15">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault6"
                        />
                        <label
                          className="form-check-label cms-6"
                          htmlFor="flexRadioDefault6"
                        >
                          Combined
                        </label>
                      </div>
                    </li>
                  </ul>
                  <a
                    href="#"
                    className="btn btn-link text-secondary fs-14 p-0 d-flex align-items-center justify-content-end mt-3 mb-3"
                  >
                    <i className="icon icon-chat fs-16 me-2"></i>Add Notes
                  </a>
                </div>
                <div className="card-footer bg-white d-flex p-3">
                  <a
                    href="#"
                    className="btn btn-outline-lite btn-md text-dark d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                  >
                    <i className="icon icon-mail me-2"></i> Email Agent
                  </a>
                  <a
                    href="#"
                    className="btn btn-outline-secondary btn-md ms-auto d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                  >
                    Download
                  </a>
                  <Link
                    to="/print-sheet"
                    className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                  >
                    Print
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default PrintSheet;
